// API related actions
export const FETCHING_PART_AUDIT = '@@toyota/FETCHING_PART_AUDIT';
export const FETCHED_PART_AUDIT = '@@toyota/FETCHED_PART_AUDIT';
export const FETCHED_PART_AUDIT_FAILED = '@@toyota/FETCHED_PART_AUDIT_FAILED';
export const DOWNLOADING_PART_AUDIT_FILE = '@@toyota/DOWNLOADING_PART_AUDIT_FILE';
export const DOWNLOADED_PART_AUDIT_FILE = '@@toyota/DOWNLOADED_PART_AUDIT_FILE';
export const DOWNLOADED_PART_AUDIT_FILE_FAILED = '@@toyota/DOWNLOADED_PART_AUDIT_FILE_FAILED';
export const FETCHING_PART = '@@toyota/FETCHING_PART';
export const FETCHED_PART = '@@toyota/FETCHED_PART';
export const FETCHED_PART_FAILED = '@@toyota/FETCHED_PART_FAILED';

// complementary actions
export const DELETE_PART_AUDIT_DATA = '@@toyota/DELETE_PART_AUDIT_DATA';
